import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { fetchTopicContentListFulfilled, fetchTopicContentListRejected } from "domains/customContentAndSources/actions";
import type { TopicContentListFetchAction } from "domains/customContentAndSources/actionTypes";
import type { CustomContent } from "domains/customContentAndSources/types";

export function* getTopicContentSaga({ payload }: TopicContentListFetchAction) {
  try {
    const response: CustomContent[] = yield apiFetch(`topic/${payload.topicId}/attachment`, {
      queryParams: {
        offset: payload.offset ?? 0,
        limit: payload.limit ?? 20,
      },
    });
    yield put(fetchTopicContentListFulfilled(response, payload));
  } catch {
    yield put(fetchTopicContentListRejected({ logoutOnAuthError: true, ...payload }));
  }
}
